import React, { FC } from 'react';
import { Switch } from 'react-router-dom';
import { Route } from 'react-router';

import LogsTable from '../components/admin/log/table';
import HistoryTable from '../components/admin/history/table';
import Error404 from './errors/404';
import VarsTable from '../components/admin/vars/table';

const ServicePage: FC = () => {
  return (
    <Switch>
      <Route exact path="/logs" component={LogsTable} />
      <Route exact path="/history" component={HistoryTable} />
      <Route exact path="/vars" component={VarsTable} />
      <Route path="*" component={Error404} />
    </Switch>
  );
};

export default ServicePage;
